import setObject from './set-object.js'

export default function setWithExpiry(key, value, ttl = null) {

    if(ttl == null) {
        // 12 hour
        ttl = 1000 * 3600 * 12;
    }

    setObject(key, {
        value: value,
        expiry: new Date().getTime() + ttl
    });
}